import emailjs from '@emailjs/browser';

export const emailjs_init = (publicKey) => emailjs.init({
    publicKey: publicKey,
    // Do not allow headless browsers
    blockHeadless: true,

    limitRate: {
        // Set the limit rate for the application
        id: 'app',
        // Allow 1 request per 10s
        throttle: 10000,
    },
});